import React from 'react'
import { Link, NavLinkProps } from 'react-router-dom'

export function PrimaryLinkButton(props: NavLinkProps): JSX.Element {
    return (
        <Link {...props} className={'transition duration-150 ease-in-out hover:bg-indigo-600 focus:outline-none border bg-indigo-700 rounded text-white px-8 py-2 text-sm ' + (props.className || '')}>
            {props.children}
        </Link>
    )
}